<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" :id="config.id + '_container'" class="control e-control" :data-test-id="dataTestId" :ref="dataTestId + '_container'">
        <div class="clearfix">
            <div v-bind="config" role="list" data-ripple="true">
                <label-wrapper :label-settings="labelSettings"></label-wrapper>
                <div v-if="!controlUpdating">
                    <div v-if="config.isDraggable">
                        <div v-for="(data, index) in options"
                             @click="action(data, 'onclick')"
                             :key="data.originKey" role="option"
                             :data-uid="index" aria-level="1"
                             :id="'element_'+index"
                             :data-test-id="dataTestId + '_' + index"
                             aria-selected="false"
                             @drop="onDragEnd($event, index)"
                             :draggable="!data.disabled ? true : false"
                             @dragstart="onDragStart($event, index)"
                             @dragenter="onDragEnter($event, index)"
                             @dragover.prevent
                             @dragenter.prevent
                        >
                            <div class="e-text-content" role="presentation">
                                <list-item :data="data"></list-item>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-for="data in options" @click="action(data, 'onclick')" :key="data.originKey" role="option" :data-uid="data.originKey" aria-level="1" :id="dataTestId + '_element_' + data.originKey" :data-test-id="dataTestId + '_' + data.key" aria-selected="false">
                            <div class="e-text-content" role="presentation">
                                <list-item :data="data"></list-item>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { library } from "@common/library/library";
import { controlMixins } from "./controlMixins.js";
import { listItemComponent } from "./listItem";

let editorSettings = {};

export const listComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    computed: {
        labelSettings() {
            if (!this.config.labelSettings) return {};
            let output = this.config.labelSettings;
            if (!output.id) output.id = this.config.id;
            return output;
        }
    },
    data() {
        return {
            controlUpdating: false,
            dragKey: false
        };
    },
    components: {
        'list-item': listItemComponent,
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        onDragEnter(event, dropKey) {
            if (this.dragKey !== dropKey) {
                let overElements = document.getElementsByClassName('over');
                for (let i = 0; i < overElements.length; i++) {
                    overElements[i].classList.remove('over');
                }
                event.currentTarget.classList.add('over');
            }
        },
        onDragEnd(event, dropKey) {
            if (this.dragKey !== false) {
                this.controlUpdating = true;
                let items = library.cloneObj(this.options);
                items = library.arrayMove(items, this.dragKey, dropKey);
                for (let i = 0; i < items.length; i++) {
                    items[i].key = i;
                }
                this.options = library.cloneObj(items);
                this.action(library.cloneObj(items), 'onchangeorder');
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.controlUpdating = false;
                    }, 500);
                });
            }
            this.dragKey = false;
        },
        onDragStart(event, key) {
            this.dragKey = key;
        }
    }
};

export default listComponent;
</script>

<style scoped>
.over {
    background-color: lightgrey;
}
</style>
